<cft-content-section [title]="section().title" [titleAlignment]="'left'">
  <div class="grid-4-cols-teaser-cards">
    @let articles = articles$() | async;
    @for (article of articles; track article.slug) {
      <a [routerLink]="article.path">
        <cft-teaser-card [attr.id]="article.slug + '-card'" [image]="article.headerImage">
          <cft-teaser-card-title>{{ article.title }}</cft-teaser-card-title>
        </cft-teaser-card>
      </a>
    }
  </div>
</cft-content-section>
